module.exports = __webpack_public_path__ + "static/media/gunpla.0e44eee5.png";